import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Badge } from '../ui/badge'
import { Card, CardContent } from '../ui/card'
import { ImageWithFallback } from '../../utils/ImageWithFallback'
import { Button } from '../ui/button'

// Inline SVG icons to avoid external dependencies
const Star = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
)
const Quote = ({ className }) => (

  <svg
    height="800px"
    width="800px"
    version="1.1"
    id="_x32_"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className={className}
  >
    <g>
      <path
        fill='#7fca9b'
        className={className}
        d="M119.472,66.59C53.489,66.59,0,120.094,0,186.1c0,65.983,53.489,119.487,119.472,119.487
        c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.135,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.829-6.389
        c82.925-90.7,115.385-197.448,115.385-251.8C238.989,120.094,185.501,66.59,119.472,66.59z"
      />
      <path
        fill='#7fca9b'
        className={className}
        d="M392.482,66.59c-65.983,0-119.472,53.505-119.472,119.51c0,65.983,53.489,119.487,119.472,119.487
        c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.136,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.828-6.389
        C479.539,347.2,512,240.452,512,186.1C512,120.094,458.511,66.59,392.482,66.59z"
      />
    </g>
  </svg>
)
const ChevronLeft = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
)
const ChevronRight = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M9 18l6-6-6-6" />
  </svg>
)
const Leaf = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M10 21c-.4 0-.8-1-1.2-3-.4-2-1.6-4-2.8-6.1-1.2-2.1-2-4.2-2-6.1S3.6 1.7 6 1s4.4 1 6.1 2.8c1.7 1.8 3.2 4.1 3.9 6.2 1 2.6 1.5 5.5 1.5 8.7a1 1 0 0 1-2 0c0-2.8-.5-5.5-1.4-8.1-.6-1.9-1.9-4.1-3.6-5.8C8.9 3.5 6.5 3 6 3c-1.3 0-1.7.5-1.7.5s-.7 2.1-.2 4.3c.5 2.2 1.4 4.5 2.2 6.5.8 2 1.5 4 1.5 6.2a1 1 0 0 1-2 0z" />
  </svg>
)
const MapPin = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 2C8.686 2 6 4.686 6 8s6 14 6 14 6-14 6-14S15.314 2 12 2zm0 10.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
  </svg>
)
const ThumbsUp = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M17 14V3L7 5l1 18h9c1.657 0 3-1.343 3-3V6c0-1.657-1.343-3-3-3zM7 16h3" />
  </svg>
)

export default function TestimonialsComponent2() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0)

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Homeowner',
      location: 'Beverly Hills, CA',
      image:
        'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face',
      rating: 5,
      date: 'September 2025',
      project: 'Complete Backyard Makeover',
      content:
        'Gardenly Thumb transformed our boring backyard into an absolute paradise! The team was professional, creative, and went above and beyond our expectations. Our new garden is the envy of the neighborhood, and we spend every evening out there now. The attention to detail and quality of work is simply outstanding.',
      beforeImage:
        'https://images.unsplash.com/photo-1549421272-b8ec11a43a0e?q=80&w=200',
      afterImage:
        'https://images.unsplash.com/photo-1494295551322-1d573d8c1c23?q=80&w=200',
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'Business Owner',
      location: 'Santa Monica, CA',
      image:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
      rating: 5,
      date: 'September 2025',
      project: 'Commercial Landscaping',
      content:
        'We hired Gardenly Thumb to redesign the landscaping around our office building, and the results exceeded all expectations. The modern, sustainable design perfectly reflects our company values. Our employees love the outdoor spaces, and clients always comment on how beautiful our grounds look. Highly recommended!',
      beforeImage:
        'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=200',
      afterImage:
        'https://images.unsplash.com/photo-1533965902095-2070c5286598?q=80&w=200',
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      role: 'Property Manager',
      location: 'Pasadena, CA',
      image:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
      rating: 5,
      date: 'September 2025',
      project: 'Residential Complex Landscaping',
      content:
        "As a property manager, I've worked with many landscaping companies, but Gardenly Thumb stands out for their reliability, quality, and communication. They maintain our property beautifully and always respond quickly to any requests. The residents are constantly complimenting the grounds.",
      beforeImage:
        'https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=200',
      afterImage:
        'https://images.unsplash.com/photo-1558904541-efa843a96f01?q=80&w=200',
    },
    {
      id: 4,
      name: 'David Thompson',
      role: 'Restaurant Owner',
      location: 'West Hollywood, CA',
      image:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
      rating: 5,
      date: 'September 2025',
      project: 'Outdoor Dining Area',
      content:
        'Gardenly Thumb created the most beautiful outdoor dining space for our restaurant. The design is both functional and stunning, creating the perfect ambiance for our guests. Since the renovation, our outdoor seating is always fully booked. The plants they chose are thriving and low-maintenance.',
      beforeImage:
        'https://images.unsplash.com/photo-1519378058457-4c29a0a2efac?q=80&w=200',
      afterImage:
        'https://images.unsplash.com/photo-1519378058457-4c29a0a2efac?q=80&w=200',
    },
    {
      id: 5,
      name: 'Lisa Park',
      role: 'Homeowner',
      location: 'Manhattan Beach, CA',
      image:
        'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face',
      rating: 5,
      date: 'September 2025',
      project: 'Front Yard Redesign',
      content:
        "We wanted to increase our home's curb appeal, and Gardenly Thumb delivered beyond our wildest dreams. The new front yard design is absolutely gorgeous and has increased our property value significantly. Neighbors stop by just to admire the landscaping! The team was professional and completed everything on time.",
      beforeImage:
        'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=200',
      afterImage:
        'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=200',
    },
  ]

  const currentReview = testimonials[currentTestimonial]

  // Auto-advance testimonials
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)
    }, 6000)

    return () => clearInterval(timer)
  }, [testimonials.length])

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)
  }

  const prevTestimonial = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    )
  }

  return (
    <section className="py-20 bg-gray-50 text-gray-900 font-sans antialiased">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Badge className="mb-4 bg-emerald-200 text-emerald-800">
            <Leaf className="w-4 h-4 mr-2" />
            Kind Words
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Our Clients are Like Family
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Discover the heartfelt stories of those who trusted us to bring
            their outdoor visions to life.
          </p>
        </motion.div>

        {/* Main Testimonial Card */}
        <div className="relative max-w-4xl mx-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentTestimonial}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.5 }}
            >
              <Card className="rounded-3xl border-0 bg-white shadow-2xl p-0">
                <div className="flex flex-col-reverse lg:grid lg:grid-cols-2">
                  {/* Testimonial Content */}
                  <CardContent className="flex flex-col justify-center text-center lg:text-left bg-white p-8 lg:p-12">
                    {/* Quote Icon */}
                    <Quote className="w-12 h-12 text-emerald-600 mx-auto lg:mx-0 mb-6" />

                    {/* Testimonial Content */}
                    <blockquote className="text-xl font-medium text-gray-800 leading-relaxed italic mb-8">
                      "{currentReview.content}"
                    </blockquote>

                    {/* Client Info */}
                    <div className="text-center lg:text-left">
                      <div className="font-bold text-xl text-gray-900">
                        {currentReview.name}
                      </div>
                      <div className="text-gray-600 text-sm">
                        {currentReview.role}
                      </div>
                      <div className="flex items-center justify-center lg:justify-start text-sm text-gray-500 mt-2">
                        <MapPin className="w-4 h-4 mr-1 text-gray-400" />
                        {currentReview.location}
                      </div>
                    </div>
                  </CardContent>

                  {/* Client Image and Ratings */}
                  <div className="relative p-6 bg-emerald-100 flex flex-col items-center justify-center rounded-t-3xl lg:rounded-l-none lg:rounded-r-3xl">
                    <ImageWithFallback
                      src={currentReview.image}
                      alt={currentReview.name}
                      className="w-32 h-32 rounded-full object-cover mb-4 ring-4 ring-white ring-offset-2 ring-offset-emerald-100"
                    />

                    {/* Ratings and Project */}
                    <div className="text-center">
                      <div className="flex justify-center items-center mb-2">
                        {[...Array(currentReview.rating)].map((_, i) => (
                          <Star
                            key={i}
                            className="w-6 h-6 fill-amber-400 text-amber-400"
                          />
                        ))}
                      </div>
                      <p className="text-sm text-gray-600 mb-2">
                        Project:{' '}
                        <span className="font-semibold">
                          {currentReview.project}
                        </span>
                      </p>
                      <p className="text-sm text-gray-600 flex items-center justify-center">
                        <ThumbsUp className="w-4 h-4 mr-1 text-emerald-600" />A
                        perfect 5-star review!
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Navigation and Indicators */}
        <div className="flex flex-col items-center mt-8">
          {/* Dots Indicator */}
          <div className="flex justify-center space-x-2 mb-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentTestimonial
                  ? 'bg-green-600 w-8'
                  : 'bg-gray-300'
                  }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
          {/* Navigation Buttons */}
          <div className="flex space-x-4">
            <Button
              className="p-0 w-14 h-14 bg-white shadow-md text-emerald-600 hover:bg-emerald-50"
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
            >
              <ChevronLeft className="w-8 h-8" />
            </Button>
            <Button
              className="p-0 w-14 h-14 bg-white shadow-md text-emerald-600 hover:bg-emerald-50"
              onClick={nextTestimonial}
              aria-label="Next testimonial"
            >
              <ChevronRight className="w-8 h-8" />
            </Button>
          </div>
        </div>


      </div>
    </section>
  )
}
